import { DefaultApolloClient } from "@vue/apollo-composable";
import ElementPlus from "element-plus";
import { createApp, h, provide } from "vue";

import apolloClient from "@/graphql";
import App from "@/pages/App/App.vue";
import useGlobalComponent from "@/plugins/global-components";
import useSentry from "@/plugins/sentry";
import router from "@/router";
import { definePreset } from "@primeuix/themes";
import Lara from "@primeuix/themes/lara";
import "@voodoo.io/voodoo-ui/dist/style.css";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import "primeicons/primeicons.css";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import "./styles/_element-ui-override.scss";
import "./styles/_fonts.scss";
import "./styles/app.scss";

// import usePermissions from "@/hooks/use-permissions";

// declare global {
//   interface Window {
//     Appcues: any;
//   }
// }

// const { canAccessAppcues } = usePermissions();

const LaraPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
  },
});

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  render: () => h(App),
  // watch: {
  //   $route() {
  //     if ((canAccessAppcues.value, window.Appcues)) {
  //       window.Appcues.page();
  //     }
  //   },
  // },
});

app.use(ElementPlus);
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: LaraPreset,
    options: {
      cssLayer: {
        name: "primevue",
        order: "app-styles, primevue",
      },
      darkModeSelector: false,
    },
  },
});
app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);
app.use(FloatingVue);

useSentry(app);
useGlobalComponent(app);

app.mount("#app");
